module.exports = __webpack_public_path__ + "img/lg-exhaust-pipe.01eb8b34.png";